//import { HttpClient, HttpHandler} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { UserService } from '../../services/user.service';
import { StorageProvider } from '../../providers/storage/storage';


/*
  Generated class for the AuthDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthDataProvider {
  public db: any;
  public MenuProfile: any = {};
  private usersCollection: AngularFirestoreCollection<any>;

  constructor(public afsModule: AngularFirestore,
    public userService: UserService,
    public afAuth: AngularFireAuth,
    public storageProvider: StorageProvider) {
    //console.log('Hello AuthDataProvider Provider');
    this.usersCollection = afsModule.collection<any>('users');
    this.db = firebase.firestore();

console.log("AUTH-DATAAAAAA", this.usersCollection);


  }

  setUserData(): Promise<any> {

    return new Promise((resolve, reject) => {
      try {
        this.getUserProfile().then(userProfileData => {
          this.userService.user = userProfileData;
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  // getUserProfileMenu() {
  //   let ion = this;
  //   this.getAuthUser().then(function(resdevice) {
  //     ion.afsModule.collection('users').doc(resdevice).ref.get().then(function (Userdoc) {
  //       if (Userdoc.exists) {
  //       ion.MenuProfile = Userdoc.data();
  //       }
  //     }).catch(function (error) {
  //       console.error("Error getting document:", error);
  //     });
  //   })
  // }

  getUserProfile(): Promise<any> {
    let ion = this;
    return new Promise((resolve, reject) => {
      try {
        this.getAuthUser().then(function (resdevice) {
          if (resdevice != null) {
            ion.afsModule.collection('/users/').doc(resdevice).ref.get().then(function (Userdoc) {
              // console.log("USERDOC", Userdoc)
              if (Userdoc.exists) {
                let userData = Userdoc.data();
                userData.userID = Userdoc.id;
                resolve(userData);
              } else {
                console.error("No such document!, Error in register");
              };

            }).catch(function (error) {
              console.error("Error getting document:", error);
            });
          } else {
            resolve(false);
          }

        });
      } catch (error) {
        reject(error);
      }
    });
  }

  getAuthUser(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (firebase.auth().currentUser) {
        this.storageProvider.get('deviceId').then(resdevice => {
          console.log("DEVICE ID DETECTADO Y USUARIO AUTENTICADO", resdevice);
          let logged = true;
          console.log("LOGGED", logged);
          resolve(resdevice);
        })
        // var deviceid = "U2X1mi8jmYwHxtVx88Fv";
        // resolve(deviceid);
      } else {
        // var deviceid = "U2X1mi8jmYwHxtVx88Fv";
        // resolve(deviceid);
        // let logged = false;
        // this.storageProvider.get('deviceId').then(resdevice => {
        //   console.log("DEVICE ID DETECTADO PERO USUARIO NO AUTENTICADO", resdevice);
        //   let logged = false;
        //   console.log("LOGGED",logged );
        //   resolve(resdevice);
        // })
      }
    })
  }


  ///////////////////////////
  getUserEmail(email): Promise<any> {

    return new Promise((resolve, reject) => {
      let ion = this;
      //let usersAccount = ion.db.collection("users");
      console.log("Este es el Email logueado actualmente", email);
      ion.usersCollection.ref.where("email", "==", email).get()
        .then(snapShot => {
          snapShot.forEach(userObject => {
            console.log("Esto es el OBJETO user" ,userObject.data())
            //let objUserEmail = JSON.parse(JSON.stringify(userEmail.data()));
            resolve(userObject.data());
          });
        })
        .catch(function (err) {
          console.error('error obtaining messages.', err);
          reject(err);
        });
    });
  }
  ////////////////////////////

  updateProfile(user) {
    let ion = this;
    console.log("updateProfile(user)", user);
    return new Promise((resolve, reject) => {
      try {
        ion.getAuthUser().then(function (resdevice) {
          ion.afsModule.collection('/users/').doc(resdevice).ref.update(user);
          resolve(true);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  loginUser(credentials): Promise<any> {
    return this.afAuth.auth.signInWithEmailAndPassword(credentials.email, credentials.password)
  }

  registerUser(registerForm: any, devideId: any): Promise<any> {
    return this.afAuth.auth.createUserWithEmailAndPassword(registerForm.email, registerForm.password).then((newUser) => {
      console.log(newUser.user)
      console.log(registerForm)
      this.usersCollection.doc(devideId).update({
        email: registerForm.email,
        first_name: registerForm.first_name,
        last_name: registerForm.last_name,
        username: registerForm.username,
        UID: newUser.user.uid
      }).catch(function (error) {
        console.error("ERRRORRR:", error);
      });
    });
  }

  logoutUser(): Promise<any> {
    return this.afAuth.auth.signOut();
  }

  forgotPasswordUser(email: any) {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth-data/auth-data.ts